import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useTranslations } from "examsbook-react-sdk/custom-hooks";
import { Avatar, Box, Button, List, ListItem, Tooltip, Typography, useMediaQuery } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { reactGaEvent, recentCourseListAction } from "examsbook-react-sdk/actions";
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { ColorsConstant } from "../../constants/colorConstant";
import { getLeaderboard } from "examsbook-react-sdk/actions/getLeaderboard";
import { setCourseId, setCourseName, setCourseProgress } from "examsbook-react-sdk/actions/getCourses";
import { LinearProgressWithLabel } from "../MyCourseCard/MyCoursesCard";
import { useTheme } from "../../constants/themeProvider";
import { useTheme as useMuiTheme } from "@material-ui/core/styles";


const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    padding: 20,
    marginBottom: 14,
    borderRadius: "8px",
    background: "#FFFFFF",
    maxHeight: "240px",
    display: "flex",
    flexDirection: "column",
    border: '1px solid #75768029',
    "@media (max-width: 767px)": {
      maxHeight: "inherit",
      marginBottom: 20,
    },
  },
  title: {
    color: "#000000",
    fontSize: "1rem",
    fontWeight: 400,
    lineHeight: "21px",
    display: "flex",
    justifyContent: "space-between",
    textTransform: "capitalize",
    "& p": {
      margin: 0,
      '@media (max-width: 767px)': {
        fontSize: '14px !important'
      }
    },
  },
  topTitle: {
    "@media (max-width: 767px)": {
      marginBottom: 10,
      fontSize: '14px !important'
    },
  },
  disableContinueBtn: {
    opacity: "0.5",
    cursor: "not-allowed !important"
  },
  expireTag: {
    fontStyle: "italic",
    color: "red",
    fontSize: "12px",
  },
  courseCreatorsBox: {
    display: "flex",
    gap: "12px",
    padding: "10px",
    alignItems: "center",
  },
  courseCreatorsName: {
    color: ColorsConstant.descriptionColor,
    fontWeight: 400,
    fontSize: "16px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: "30ch",
    '@media (max-width: 767px)': {
      fontSize: 14,

    }
  },
  courseCreatorsDescription: {
    color: "#000000DE",
    fontSize: "12px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: "30ch",
  },
  learningBox: {
    background: "#FFFFFF",
    borderRadius: "8px",
    height: '100%',
    border: '1px solid #75768029',
    "@media (max-width: 959px)": {
      height: "inherit",
    },
  },
  resumeLearningBox: {
    display: "flex",
    flexDirection: "column",
    gap: "15px",
    cursor: "pointer",
    padding: '0px 20px',
    "@media (max-width: 767px)": {
      height: "inherit",
    },
  },
  resumeLearningContent: {
    display: "flex",
    flexDirection: "column",
    padding: "15px",
    border: `1px solid ${ColorsConstant.cardBorders}`,
    borderRadius: "15px",
    cursor: "pointer",
    },
  
  suggestedCoursesBox: {
    display: "flex",
    gap: "10px",
    padding: "10px",
    marginBottom: "15px",
  },
  suggestedCoursesImgAlign: {
    background: "#ECEFF1",
    padding: "30px 5px",
  },
  suggestedCoursesData: {
    display: "flex",
    flexDirection: "column",
    alignSelf: "center",
  },
  resumeLearningDescription: {
    fontSize: "12px",
    color: "#000000B2",
    overflow: "hidden",
    WebkitBoxOrient: "vertical",
    display: "-webkit-box",
    textOverflow: "ellipsis",
    WebkitLineClamp: "3",
    '& *': {
      margin: 0
    }
  },
  suggestedCoursesHeading: {
    margin: "20px 0px",
    borderTop: "1px solid #0000001F",
    paddingTop: "20px",
  },
  suggestedCoursesContent: {
    overflowY: "auto",
    height: "40%",
  },
  userImage: {
    width: '45px',
    height: '45px',
    borderRadius: '50%',
  },
  userDesc: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  leaderboardBox: {
    background: "#FFFFFF",
    display: "flex",
    flexDirection: "column",
    '& ul': {
      '&:first-child': {
        backgroundColor: '#F9FAFB', padding: '10px', borderBottom: '1px solid #F5F5F5', fontWeight: '600',
      },
      display: 'flex', padding: '10px',
      '& li': {
        justifyContent: 'center', listStyle: 'none', color: ColorsConstant.descriptionColor, width: '33.33%', padding: '10px', display: 'flex', alignItems: 'center',
      }
    }
  },
  leaderboardListAlign: {
    borderBottom: '1px solid #E5E7EB',
  },
  noLeaderboardFound: {
    padding: "20px",
    textAlign: "center",
    fontSize: '14px'
  },
  leaderboardColumn: {
    flex: 1,
    textAlign: "left",
    padding: "10px 15px",
    fontSize: "14px !important",
  },
  highlightedRow: {
    fontWeight: "600 !important",
  },
  youTag: {
    background: "#0C3450",
    color: "#FFFFFF",
    fontSize: "10px",
    fontWeight: "600",
    padding: "2px 6px",
    borderRadius: "10px",
    position: 'relative',
    left: '10px'
  },
  viewLeaderboardButtonBox: {
    display: "flex",
    justifyContent: "flex-end",
    paddingRight: "12px",
    marginTop: '8px',
    paddingBottom: '20px'
  },
  viewLeaderboardButton: {
    textTransform: "capitalize",
  },
  uppercaseText: {
    textTransform: "uppercase",
  },
  leaderboardText: {
    marginBottom: '14px'
  }
}));

export default function CourseCard(props) {
  const classes = useStyles();
  const t = useTranslations();
  const theme = useTheme();
  const [showExpireTag, setShowExpireTag] = useState(false);
  const [expireDays, setExpireDays] = useState(false);
  const [shouldScroll, setShouldScroll] = useState(false);
  const user = useSelector((state) => state.user);
  const userId = user?.user?._id ? user?.user?._id : user?._id;
  const dispatch = useDispatch();
  const history = useHistory();
  const [leaderboardData, setLeaderboardData] = useState([]);
  const skipPosts = 0;
  const search = '';
  const location = useLocation();
  const courseId = props?.courseId ? props?.courseId : props?.courseData?._id || location?.state?.courseId;
  const [isLoading, setIsLoading] = useState(false);
  const length = 6;
  const muiTheme = useMuiTheme();
  const isMobile = useMediaQuery(muiTheme.breakpoints.down("sm"));
  let recentCourseData = useSelector((state) => state.recentCourseList);
  const courseName = useSelector(state => state.filteredCourseList.courseName);
  const courseProgress = useSelector(state => state.filteredCourseList.courseProgress) || 0;
  const showEvaluationTest = useSelector(state => state.filteredCourseList.showEvaluationTest) || location?.state?.showEvaluationTest;
  const showInstructions = useSelector(state => state.filteredCourseList.showInstructions) || location?.state?.showInstructions;

  // useEffect will handle the scroll behavior
  useEffect(() => {
    if (shouldScroll && window.innerWidth <= 959) {
      const courseInfoSection = document.getElementById("course-info-section");
      if (courseInfoSection) {
        courseInfoSection.scrollIntoView({ behavior: "smooth" });
      }
      setShouldScroll(false); // reset flag after scroll
    }
  }, [shouldScroll]);

  useEffect(() => {
    getLeaderBoardData();
  },[courseId]);

  const getLeaderBoardData = async () => {
    try {
        await dispatch(getLeaderboard(length, skipPosts, search, courseId)).then((res) => {
            setLeaderboardData(res?.userList ? res?.userList : []);
            setIsLoading(true);
        });
    } catch (error) {
        console.log("Error -", error.message);
        setLeaderboardData([]);
    }
  };

  useEffect(() => {
    userId && dispatch(recentCourseListAction(userId));
  }, [userId]);

  useEffect(() => {
    if (props?.courseData !== undefined && props?.courseData?.endDate) {
      checkExpiration();
    }
  }, []);

  const checkExpiration = () => {
    const currentDate = new Date();
    let courseEndDate = new Date(props?.courseData?.endDate);
    const timeDifference = courseEndDate.getTime() - currentDate.getTime();
    setExpireDays(Math.ceil(timeDifference / (1000 * 60 * 60 * 24)));
    const daysDifference = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));

    if (daysDifference <= 7 && daysDifference > 0) {
      setShowExpireTag(true);
    }
  };

  const courseCreators = [
    {
      img: props?.courseData?.created?.by?.image,
      name: props?.courseData?.created?.by?.name,
      description: props?.courseData?.created?.by?.department,
    },
  ];

  function handleGoToTestClick(item) {
    window.dispatchEvent(new Event("storage"));
    reactGaEvent("Course Material", "Go To Course");
    dispatch(setCourseName(item?.name));
    dispatch(setCourseId(item?._id));
    dispatch(setCourseProgress(item?.progressPercent));
    // Navigate to the course
    history.push(`/course/${item?._id}`, {
      courseId: item?._id,
      subjectId: "",
      topicId: "",
      subjectDetail: item,
      subjectName: "",
      topicName: "",
      courseName: courseName,
      courseProgress: courseProgress,
      showEvaluationTest: showEvaluationTest,
      showInstructions: showInstructions
    });
    // Trigger scroll action
    setShouldScroll(true);
  }

  const handleViewLeaderboard = () => {
    history.push(`/course/leaderboard/${props?.courseId}`, {params: { courseId: props?.courseId, courseName: props?.courseData?.name } });
  }

  // Always show (current user) at the top of the leaderboard
  const youData = leaderboardData?.find(row => row?._id === userId);
  const restData = leaderboardData?.filter(row => row?._id !== userId);
  const displayLeaderboardData = youData ? [youData, ...restData] : restData;

  // Determine which columns to show based on data
  const hasName = displayLeaderboardData.some(row => row.name);
  const hasPoints = displayLeaderboardData.some(row => row.totalAwardedPoints !== undefined && row.totalAwardedPoints !== null && row.totalAwardedPoints !== '');
  const hasRank = displayLeaderboardData.some(row => row.rank !== undefined && row.rank !== null && row.rank !== '');

  return (
    <>
      <Box className={classes.root}>
        <Box className={`${classes.title} ${classes.topTitle}`}>
          <Typography variant="inherit">
            {t("Course Creators")}
          </Typography>
          {showExpireTag && (
            <Typography variant="inherit" className={classes.expireTag}>{`${t(
              "Expires in"
            )} ${expireDays} ${
              expireDays === 1 ? t("day") : t("days")
            }`}</Typography>
          )}
        </Box>
        <Box className="course-creators" style={{ overflowY: "auto" }}>
          {courseCreators.map((item, index) => {
            return (
              <Box className={classes.courseCreatorsBox} key={index}>
                <Avatar className={classes.userImage} src={item?.img} style={{backgroundColor: !item?.img ? theme?.primaryColor : undefined}} />
                <Box className={classes.userDesc}>
                  <Tooltip title={item?.name} placement="top-start">
                    <Box className={classes.courseCreatorsName}>{item?.name}</Box>
                  </Tooltip>
                  {item?.description && <Tooltip title={item?.description} placement="top-start">
                    <Box className={classes.courseCreatorsDescription}>
                      {item?.description}
                    </Box>
                  </Tooltip>}
                </Box>
              </Box>
            );
          })}
        </Box>
      </Box>
          <Box className={`${classes.learningBox} ${classes.leaderboardText}`}>
            <Box className={classes.title} style={{ paddingBottom: "20px", paddingLeft: "20px", paddingTop: '20px' }}>
              <Typography variant="body1" style={{ fontSize: "16px", fontWeight: "400" }}>
                {t("Leaderboard")}
              </Typography>
            </Box>
            {leaderboardData?.length > 0 && (
              <Box className={classes.leaderboardBox}>
                {(hasName || hasPoints || hasRank) && (
                  <List className={classes.uppercaseText}>
                    {hasName && <ListItem>{t("name")}</ListItem>}
                    {hasPoints && <ListItem>{t("Points")}</ListItem>}
                    {hasRank && <ListItem>{t("rank")}</ListItem>}
                  </List>
                )}
                {displayLeaderboardData?.map((row, index) => (
                  <List
                    className={`${classes.leaderboardListAlign} ${row?._id === userId && classes.highlightedRow}`}
                    key={index}
                  >
                    {hasName && (
                      <ListItem>
                        {row.name}{" "}
                        {row?._id === userId && (
                          <Box variant="span" className={classes.youTag}>
                            {t("You")}
                          </Box>
                        )}
                      </ListItem>
                    )}
                    {hasPoints && <ListItem>{row?.totalAwardedPoints}</ListItem>}
                    {hasRank && <ListItem>{row?.rank}</ListItem>}
                  </List>
                ))}
                <Box className={classes.viewLeaderboardButtonBox}>
                  <Button
                    style={{color: theme?.primaryColor, borderColor: theme?.primaryColor}}
                    variant="outlined"
                    onClick={handleViewLeaderboard}
                    className={classes.viewLeaderboardButton}
                  >
                    {t("View Leaderboard")}
                  </Button>
                </Box>
              </Box>
            )}
            {leaderboardData?.length === 0 && isLoading && (
              <Typography variant="body1" className={classes.noLeaderboardFound}>
                {t("No leaderboard record found")}
              </Typography>
            )}
          </Box>
          <Box className={classes.learningBox} style={{paddingBottom: '14px', marginBottom: '14px'}}>
            <Box className={classes.title} style={{ paddingBottom: "20px", paddingLeft: '20px', paddingTop: '20px' }}>
              <Typography variant="body1" style={{ fontSize: "16px", fontWeight: "400" }}>
                {t("Resume Learning")}
              </Typography>
            </Box>
            <Box className={classes.resumeLearningBox}>
              {recentCourseData?.recentCourseList?.length > 0 &&
                recentCourseData?.recentCourseList?.map((item, index) => {
                  const isDisabled = item?.assignedCourseEndDate < new Date();
                  return (
                    <Box
                      onClick={() => {
                        if (isDisabled) return;
                        handleGoToTestClick(item);
                      }}
                      className={`${classes.resumeLearningContent} ${isDisabled ? classes.disableContinueBtn : ""
                        }`}
                      key={index}
                    >
                      <Typography variant="body1" style={{ color: "#000000DE", fontSize: isMobile && '14px'  }}>
                        {item?.name}
                      </Typography>
                      <LinearProgressWithLabel value={item?.progressPercent || 0} />
                      <Typography
                        variant="inherit"
                        className={classes.resumeLearningDescription}
                        dangerouslySetInnerHTML={{ __html: item?.description }}
                      />
                    </Box>
                  );
                })}
            </Box>
          </Box>
    </>
  );
}
